<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pQN6AW/tc-custom/cover.jpg?1684514558525?1706297158251" alt="This image is the cover for the book Oil & Gas Industry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oil & Gas Industry
      </h1>
      <p class="bookDescription body article font2">
        <p>Joseph Hilyard's timely new book provides a broad perspective on the oil and gas industry, with primary attention to the United States. It takes the reader on a tour of the operations used to find and evaluate resources, and then to produce, store and deliver oil and gas. The book's main focus is primarily on the equipment and processes used in exploring new resources; evaluating promising formations; drilling wells; managing oil and gas production; converting oil and gas into products; and transporting oil and gas. Separate chapters address the evolution and current structure of the petroleum industry; oil and gas trading; and challenges likely to face the oil and gas industry in coming years. Three appendices define key industry terminology; suggest further reading on selected topics; and identify organizations that can provide more information.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Hilyard
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d75cab28